// extracted by mini-css-extract-plugin
export default {"popover":"popover--gfQL","content":"content--+p8V","close-button":"close-button--b6L1","children-wrapper":"children-wrapper--O7+K"};